import TapToSay from './TapToSay.vue';
import TapToSayList from './TapToSayList.vue';
export default {
  TapToSay,
  TapToSayList,
};
